/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type MotionSensor,
    MotionSensorFromJSON,
    MotionSensorToJSON,
} from '../models/MotionSensor';
import {
    type MotionSensorSortKey,
    MotionSensorSortKeyFromJSON,
    MotionSensorSortKeyToJSON,
} from '../models/MotionSensorSortKey';
import {
    type MotionSensorUpsert,
    MotionSensorUpsertFromJSON,
    MotionSensorUpsertToJSON,
} from '../models/MotionSensorUpsert';
import {
    type PageInfo,
    PageInfoFromJSON,
    PageInfoToJSON,
} from '../models/PageInfo';
import {
    type SortDirection,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/SortDirection';

export interface MotionSensorsListMotionSensorsRequest {
    pageSize: number;
    search?: string | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: MotionSensorSortKey;
}

export interface MotionSensorsListMotionSensorsMetadataRequest {
    pageSize: number;
    search?: string | null;
}

export interface MotionSensorsUpsertMotionSensorRequest {
    motionSensorUpsert: MotionSensorUpsert;
}

export interface MotionSensorsValidateUpsertMotionSensorRequest {
    motionSensorUpsert: MotionSensorUpsert;
}

/**
 * MotionSensorsApi - interface
 * 
 * @export
 * @interface MotionSensorsApiInterface
 */
export interface MotionSensorsApiInterface {
    /**
     * Creates request options for motionSensorsListMotionSensors without sending the request
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {MotionSensorSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof MotionSensorsApiInterface
     */
    motionSensorsListMotionSensorsRequestOpts(requestParameters: MotionSensorsListMotionSensorsRequest): Promise<runtime.RequestOpts>;

    /**
     * Lists all motion sensors.
     * @summary List motion sensors
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {MotionSensorSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MotionSensorsApiInterface
     */
    motionSensorsListMotionSensorsRaw(requestParameters: MotionSensorsListMotionSensorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MotionSensor>>>;

    /**
     * Lists all motion sensors.
     * List motion sensors
     */
    motionSensorsListMotionSensors(requestParameters: MotionSensorsListMotionSensorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MotionSensor>>;

    /**
     * Creates request options for motionSensorsListMotionSensorsMetadata without sending the request
     * @param {number} pageSize 
     * @param {string} [search] 
     * @throws {RequiredError}
     * @memberof MotionSensorsApiInterface
     */
    motionSensorsListMotionSensorsMetadataRequestOpts(requestParameters: MotionSensorsListMotionSensorsMetadataRequest): Promise<runtime.RequestOpts>;

    /**
     * Fetch information about the total amount of pages available.
     * @summary Motion sensor listing metadata
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MotionSensorsApiInterface
     */
    motionSensorsListMotionSensorsMetadataRaw(requestParameters: MotionSensorsListMotionSensorsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>>;

    /**
     * Fetch information about the total amount of pages available.
     * Motion sensor listing metadata
     */
    motionSensorsListMotionSensorsMetadata(requestParameters: MotionSensorsListMotionSensorsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo>;

    /**
     * Creates request options for motionSensorsUpsertMotionSensor without sending the request
     * @param {MotionSensorUpsert} motionSensorUpsert 
     * @throws {RequiredError}
     * @memberof MotionSensorsApiInterface
     */
    motionSensorsUpsertMotionSensorRequestOpts(requestParameters: MotionSensorsUpsertMotionSensorRequest): Promise<runtime.RequestOpts>;

    /**
     * Either creates or updates a motion sensor.
     * @summary Upsert a motion sensor
     * @param {MotionSensorUpsert} motionSensorUpsert 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MotionSensorsApiInterface
     */
    motionSensorsUpsertMotionSensorRaw(requestParameters: MotionSensorsUpsertMotionSensorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MotionSensor>>;

    /**
     * Either creates or updates a motion sensor.
     * Upsert a motion sensor
     */
    motionSensorsUpsertMotionSensor(requestParameters: MotionSensorsUpsertMotionSensorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MotionSensor>;

    /**
     * Creates request options for motionSensorsValidateUpsertMotionSensor without sending the request
     * @param {MotionSensorUpsert} motionSensorUpsert 
     * @throws {RequiredError}
     * @memberof MotionSensorsApiInterface
     */
    motionSensorsValidateUpsertMotionSensorRequestOpts(requestParameters: MotionSensorsValidateUpsertMotionSensorRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for upserting a motion sensor without persisting it.  Returns an empty body if the data is valid. Returns validation errors if it is invalid.
     * @summary Validate a motion sensor
     * @param {MotionSensorUpsert} motionSensorUpsert 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MotionSensorsApiInterface
     */
    motionSensorsValidateUpsertMotionSensorRaw(requestParameters: MotionSensorsValidateUpsertMotionSensorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for upserting a motion sensor without persisting it.  Returns an empty body if the data is valid. Returns validation errors if it is invalid.
     * Validate a motion sensor
     */
    motionSensorsValidateUpsertMotionSensor(requestParameters: MotionSensorsValidateUpsertMotionSensorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class MotionSensorsApi extends runtime.BaseAPI implements MotionSensorsApiInterface {

    /**
     * Creates request options for motionSensorsListMotionSensors without sending the request
     */
    async motionSensorsListMotionSensorsRequestOpts(requestParameters: MotionSensorsListMotionSensorsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling motionSensorsListMotionSensors().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/motion_sensors/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists all motion sensors.
     * List motion sensors
     */
    async motionSensorsListMotionSensorsRaw(requestParameters: MotionSensorsListMotionSensorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MotionSensor>>> {
        const requestOptions = await this.motionSensorsListMotionSensorsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MotionSensorFromJSON));
    }

    /**
     * Lists all motion sensors.
     * List motion sensors
     */
    async motionSensorsListMotionSensors(requestParameters: MotionSensorsListMotionSensorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MotionSensor>> {
        const response = await this.motionSensorsListMotionSensorsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for motionSensorsListMotionSensorsMetadata without sending the request
     */
    async motionSensorsListMotionSensorsMetadataRequestOpts(requestParameters: MotionSensorsListMotionSensorsMetadataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling motionSensorsListMotionSensorsMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/motion_sensors/meta`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch information about the total amount of pages available.
     * Motion sensor listing metadata
     */
    async motionSensorsListMotionSensorsMetadataRaw(requestParameters: MotionSensorsListMotionSensorsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>> {
        const requestOptions = await this.motionSensorsListMotionSensorsMetadataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageInfoFromJSON(jsonValue));
    }

    /**
     * Fetch information about the total amount of pages available.
     * Motion sensor listing metadata
     */
    async motionSensorsListMotionSensorsMetadata(requestParameters: MotionSensorsListMotionSensorsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo> {
        const response = await this.motionSensorsListMotionSensorsMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for motionSensorsUpsertMotionSensor without sending the request
     */
    async motionSensorsUpsertMotionSensorRequestOpts(requestParameters: MotionSensorsUpsertMotionSensorRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['motionSensorUpsert'] == null) {
            throw new runtime.RequiredError(
                'motionSensorUpsert',
                'Required parameter "motionSensorUpsert" was null or undefined when calling motionSensorsUpsertMotionSensor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/motion_sensors/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MotionSensorUpsertToJSON(requestParameters['motionSensorUpsert']),
        };
    }

    /**
     * Either creates or updates a motion sensor.
     * Upsert a motion sensor
     */
    async motionSensorsUpsertMotionSensorRaw(requestParameters: MotionSensorsUpsertMotionSensorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MotionSensor>> {
        const requestOptions = await this.motionSensorsUpsertMotionSensorRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MotionSensorFromJSON(jsonValue));
    }

    /**
     * Either creates or updates a motion sensor.
     * Upsert a motion sensor
     */
    async motionSensorsUpsertMotionSensor(requestParameters: MotionSensorsUpsertMotionSensorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MotionSensor> {
        const response = await this.motionSensorsUpsertMotionSensorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for motionSensorsValidateUpsertMotionSensor without sending the request
     */
    async motionSensorsValidateUpsertMotionSensorRequestOpts(requestParameters: MotionSensorsValidateUpsertMotionSensorRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['motionSensorUpsert'] == null) {
            throw new runtime.RequiredError(
                'motionSensorUpsert',
                'Required parameter "motionSensorUpsert" was null or undefined when calling motionSensorsValidateUpsertMotionSensor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/motion_sensors/validate`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MotionSensorUpsertToJSON(requestParameters['motionSensorUpsert']),
        };
    }

    /**
     * Validate data for upserting a motion sensor without persisting it.  Returns an empty body if the data is valid. Returns validation errors if it is invalid.
     * Validate a motion sensor
     */
    async motionSensorsValidateUpsertMotionSensorRaw(requestParameters: MotionSensorsValidateUpsertMotionSensorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.motionSensorsValidateUpsertMotionSensorRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for upserting a motion sensor without persisting it.  Returns an empty body if the data is valid. Returns validation errors if it is invalid.
     * Validate a motion sensor
     */
    async motionSensorsValidateUpsertMotionSensor(requestParameters: MotionSensorsValidateUpsertMotionSensorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.motionSensorsValidateUpsertMotionSensorRaw(requestParameters, initOverrides);
    }

}
